module.exports = __webpack_public_path__ + "static/img/13-02.79b4d2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/award/13-02.png
// module id = S5Ig
// module chunks = 1